// Merkan · Englische Oberflächentexte: Vorgänge (Liste, Akte, Positionen, Kalkulation, Lieferantenangebote)
export default {
  'Keine Nachrichten zu diesem Vorgang': 'No messages for this case',
  'Mails mit der Vorgangsnummer im Betreff werden automatisch zugeordnet.': 'Emails with the case number in the subject are assigned automatically.',
  '(ohne Betreff)': '(no subject)',
  'an {liste}': 'to {liste}',
  'Anzahlung': 'Advance payment',
  'Schlussrechnung': 'Final Invoice',
  'offen': 'open',
  'teilbezahlt': 'part paid',
  'bezahlt': 'paid',
  'Dem Vorgang ist kein Kunde zugeordnet.': 'No customer is assigned to this case.',
  'Der Vorgang hat keine Positionen.': 'The case has no line items.',
  '{art} als Entwurf erzeugt.': '{art} created as draft.',
  'Angebotsfassung {n} als Entwurf erzeugt.': 'Quotation revision {n} created as draft.',
  'Auftragsbestätigung mit geänderten Positionen?': 'Order Confirmation with changed line items?',
  'Die Positionen weichen von Angebot {nummer} ab ({aenderungen}). Die Auftragsbestätigung übernimmt die aktuellen Positionen und verweist auf dieses Angebot. Alternativ zuerst eine neue Angebotsfassung erstellen.': 'The line items differ from quotation {nummer} ({aenderungen}). The Order Confirmation takes the current line items and refers to this quotation. Alternatively, create a new quotation revision first.',
  'Trotzdem erzeugen': 'Create anyway',
  'Die Auftragsbestätigung hat keinen Betrag.': 'The Order Confirmation has no amount.',
  'Anzahlungsrechnung als Entwurf erzeugt.': 'Advance Invoice created as draft.',
  'Schlussrechnung als Entwurf erzeugt.': 'Final Invoice created as draft.',
  'Angebotsentwurf öffnen': 'Open draft quotation',
  'Neue Angebotsfassung': 'New quotation revision',
  'Angebot erzeugen': 'Create Quotation',
  'Auftragsbestätigung erzeugen': 'Create Order Confirmation',
  'Rechnung erzeugen': 'Create Invoice',
  'Wird erzeugt …': 'Creating …',
  'Anzahlungsrechnung 50 % erzeugen': 'Create 50 % Advance Invoice',
  'Schlussrechnung erzeugen': 'Create Final Invoice',
  'Zuerst einen Kunden zuordnen.': 'Assign a customer first.',
  'Zuerst Positionen erfassen.': 'Add line items first.',
  "Zahlungsart 50 % bei Auftragsbestätigung, 50 % bei Versandbereitschaft. Nach der Auftragsbestätigung folgt die Anzahlungsrechnung.": "Payment terms: 50 % on order confirmation, 50 % when ready for dispatch. The advance invoice follows the order confirmation.",
  "Auftrag bestätigt. Jetzt die Anzahlungsrechnung über 50 % erzeugen.": "Order confirmed. Now create the advance invoice for 50 %.",
  "Die Anzahlungsrechnung ist noch ein Entwurf und muss gebucht werden.": "The advance invoice is still a draft and must be posted.",
  'Die Anzahlung ist noch nicht vollständig bezahlt.': 'The advance payment has not been paid in full.',
  'Die Anzahlung ist noch nicht vollständig bezahlt. Die Beschaffung startet nach Zahlungseingang.': 'The advance payment has not been paid in full. Procurement starts once payment is received.',
  'Anzahlung bezahlt. Die Ware ist versandbereit, jetzt die Schlussrechnung erzeugen.': 'Advance payment received. The goods are ready for dispatch, now create the Final Invoice.',
  'Anzahlung bezahlt. Die Schlussrechnung folgt bei Versandbereitschaft.': 'Advance payment received. The Final Invoice follows when the goods are ready for dispatch.',
  'Schlussrechnung erzeugt.': 'Final Invoice created.',
  "Zu diesem Vorgang gibt es keine gebuchte Anzahlungsrechnung. Die Schlussrechnung enthält dann keinen Abzug.": "There is no posted advance invoice for this case, so the final invoice contains no deduction.",
  'Die Anzahlung {nummern} ist noch nicht vollständig bezahlt. Der Abzug in der Schlussrechnung erfolgt trotzdem in voller Höhe.': 'Advance payment {nummern} has not been paid in full. The Final Invoice still deducts the full amount.',
  'Positionen seit Angebot {nummer} geändert: {aenderungen}.': 'Line items changed since quotation {nummer}: {aenderungen}.',
  ' Ein Entwurf der neuen Fassung liegt bereits vor.': ' A draft of the new revision already exists.',
  ' Der Kunde bestätigt die aktuelle Fassung.': ' The customer confirms the current revision.',
  'Entwurf öffnen': 'Open draft',
  'Noch keine Belege': 'No documents yet',
  'Angebot und Auftragsbestätigung entstehen aus den Positionen, danach Anzahlungs- und Schlussrechnung.': 'Quotation and Order Confirmation are created from the line items, followed by the Advance Invoice and Final Invoice.',
  'Angebot, Auftragsbestätigung und Rechnung entstehen aus den Positionen des Vorgangs.': 'Quotation, Order Confirmation and Invoice are created from the line items of the case.',
  'Art': 'Type',
  'Nummer': 'Number',
  'Status': 'Status',
  'Zahlung': 'Payment',
  'Datum': 'Date',
  'Netto': 'Net',
  'Brutto': 'Gross',
  'Fassung {n}': 'Revision {n}',
  'ersetzt': 'superseded',
  'Entwurf': 'Draft',
  'Rücksprung zu': 'Stepped back to',
  'vorher {schritt}, Daten bleiben erhalten': 'previously {schritt}, data retained',
  'Schritt': 'Step',
  'vorher {schritt}': 'previously {schritt}',
  'EK neu': 'New purchase price',
  'Pos. {n}': 'Line {n}',
  'Lieferant gewechselt:': 'Supplier changed:',
  'ohne Lieferant': 'no supplier',
  'zu': 'to',
  'Lieferant': 'Supplier',
  'gewählt': 'selected',
  'Nachricht gesendet': 'Message sent',
  'Telefonnotiz': 'Phone note',
  'Notiz im Service Hub': 'Note in Service Hub',
  'Nachricht erhalten': 'Message received',
  '{beleg} angelegt:': '{beleg} created:',
  'Anzahlungsrechnung': 'Advance Invoice',
  'Angebot Fassung {n}': 'Quotation revision {n}',
  'Notiz gespeichert.': 'Note saved.',
  'Unbekannt': 'Unknown',
  'System': 'System',
  'Notiz zum Vorgang': 'Note on this case',
  'Notiz': 'Note',
  'Notiz hinzufügen': 'Add note',
  'Noch kein Verlauf': 'No history yet',
  'Der Betreff darf nicht leer sein.': 'The subject must not be empty.',
  'Kopfdaten gespeichert.': 'Header details saved.',
  'Kopfdaten bearbeiten': 'Edit header details',
  'Abbrechen': 'Cancel',
  'Speichert …': 'Saving …',
  'Speichern': 'Save',
  'Betreff': 'Subject',
  'Kundenreferenz': 'Customer reference',
  'Bestellnummer des Kunden': 'Customer order number',
  'Erst mit der Kundenbestellung eintragen': 'Enter only once the customer has placed the order',
  'Fällig am': 'Due on',
  'Priorität': 'Priority',
  'Niedrig': 'Low',
  'Normal': 'Normal',
  'Hoch': 'High',
  'Verantwortlich': 'Assignee',
  'Niemand': 'Nobody',
  'Nächste Aktion': 'Next action',
  'z. B. an Angebot erinnern': 'e.g. follow up on quotation',
  'Bitte einen Betreff eingeben.': 'Please enter a subject.',
  'Vorgang {nummer} angelegt.': 'Case {nummer} created.',
  'Neuer Vorgang': 'New case',
  'Manuell anlegen, z. B. nach einem Telefonat': 'Create manually, e.g. after a phone call',
  'Wird angelegt …': 'Creating …',
  'Vorgang anlegen': 'Create case',
  'Kunde': 'Customer',
  'Kunde entfernen': 'Remove customer',
  'Firma oder Kundennummer': 'Company or customer number',
  'Kontakt': 'Contact',
  'Kein Kontakt': 'No contact',
  'Schiff': 'Vessel',
  'Schiff entfernen': 'Remove vessel',
  'Anderes Schiff: Name oder IMO': 'Other vessel: name or IMO',
  'Name oder IMO': 'Name or IMO',
  'z. B. Kolbenringe Hauptmotor': 'e.g. piston rings main engine',
  'Position {n} löschen?': 'Delete line {n}?',
  'Löschen': 'Delete',
  'Position gelöscht.': 'Line item deleted.',
  'Positionen': 'Line items',
  'Kalkulation': 'Costing',
  'Positionen aus Text erkennen': 'Detect line items from text',
  'Position hinzufügen': 'Add line item',
  'Noch keine Positionen': 'No line items yet',
  'Positionen von Hand erfassen oder aus dem Text der Anfrage erkennen lassen.': 'Enter line items manually or have them detected from the enquiry text.',
  'Pos': 'Line',
  'Teilenummer': 'Part number',
  'Hersteller': 'Manufacturer',
  'Bezeichnung': 'Description',
  'Aggregat': 'Unit',
  'Menge': 'Qty',
  'Einheit': 'UoM',
  'VK pro Stück': 'Sales price each',
  'Summe': 'Total',
  'Aktionen': 'Actions',
  'Bitte prüfen': 'Please check',
  'unsicher': 'uncertain',
  'gestrichen': 'cancelled',
  'KI': 'AI',
  'Position {n} bearbeiten': 'Edit line {n}',
  'Position {n} löschen': 'Delete line {n}',
  'Summe netto': 'Net total',
  'Bitte eine Bezeichnung eingeben.': 'Please enter a description.',
  'Die Menge muss größer als 0 sein.': 'The quantity must be greater than 0.',
  'Position gespeichert.': 'Line item saved.',
  'Position hinzugefügt.': 'Line item added.',
  'Position {n}': 'Line {n}',
  'Neue Position': 'New line item',
  'Artikel im Stamm suchen': 'Search item master data',
  'Teilenummer, Bezeichnung, Hersteller': 'Part number, description, manufacturer',
  'Mit Artikelstamm verknüpft': 'Linked to item master',
  'Verknüpfung lösen': 'Unlink',
  'z. B. Hauptmotor': 'e.g. main engine',
  'VK pro Stück (€)': 'Sales price each (€)',
  'Lieferzeit in Tagen': 'Lead time in days',
  'Unsicher, bitte prüfen': 'Uncertain, please check',
  'Gestrichen (vom Kunden nicht bestellt)': 'Cancelled (not ordered by customer)',
  "{ki} konnte keine Positionen erkennen.": "{ki} could not recognise any items.",
  'Im Text wurden keine Positionen gefunden.': 'No line items were found in the text.',
  'Vorbefüllt aus: {quelle}': 'Prefilled from: {quelle}',
  'Text der Anfrage einfügen': 'Paste the enquiry text',
  'Verwerfen': 'Discard',
  'Schließen': 'Close',
  'Text': 'Text',
  'Mailtext oder Liste der gewünschten Teile': 'Email text or list of required parts',
  'Erkennt …': 'Detecting …',
  'Erkennen': 'Detect',
  'Jede Position prüfen und anhaken. Nichts wird ohne Haken übernommen.': 'Check and tick each line item. Nothing is added without a tick.',
  'Alle sicheren anhaken': 'Tick all certain',
  'Keine': 'None',
  'Position {n} übernehmen': 'Add line {n}',
  'Pos {n}': 'Line {n}',
  'Sicherheit {n} %': 'Confidence {n} %',
  'Artikel {nummer}': 'Item {nummer}',
  'geändert': 'changed',
  'Lieferant nach Auftragsbestätigung wechseln?': 'Change supplier after Order Confirmation?',
  'Der Wechsel wird im Verlauf festgehalten.': 'The change is recorded in the history.',
  'Wechseln': 'Change',
  'Lieferant gewechselt zu {name}.': 'Supplier changed to {name}.',
  '{name} gewählt.': '{name} selected.',
  'Angebot von {name} löschen?': 'Delete offer from {name}?',
  'Das Angebot ist gewählt. Die Kalkulation behält ihre bisherigen Werte.': 'This offer is selected. The costing keeps its current values.',
  'Angebot gelöscht.': 'Offer deleted.',
  'Kalkulation gespeichert.': 'Costing saved.',
  'Keine Positionen zu kalkulieren': 'No line items to cost',
  'VK für alle aus EK und Aufschlag': 'Sales price for all from purchase price and mark-up',
  'Lieferantenangebot aus Text': 'Supplier offer from text',
  'Für alle Positionen übernehmen': 'Apply to all line items',
  'Vorschlag Aufschlag für {firma}: {wert} % ({anteil} %)': 'Suggested mark-up for {firma}: {wert} % ({anteil} %)',
  'Kalkulation speichern': 'Save costing',
  'Alle Angebote zuklappen': 'Collapse all offers',
  'Alle Angebote aufklappen': 'Expand all offers',
  'EK pro Stück': 'Purchase price each',
  'Aufschlag %': 'Mark-up %',
  'Fracht': 'Freight',
  'Rohertrag': 'Gross profit',
  'Angebote zu Position {n} zuklappen': 'Collapse offers for line {n}',
  'Angebote zu Position {n} aufklappen': 'Expand offers for line {n}',
  'Kein Angebot gewählt': 'No offer selected',
  'Lieferant Position {n}': 'Supplier line {n}',
  'Kein Lieferant': 'No supplier',
  'zuletzt {preis} ({datum})': 'last {preis} ({datum})',
  'Vorschlag übernehmen': 'Apply suggestion',
  'Vorschlag: {name} ({anteil} %)': 'Suggestion: {name} ({anteil} %)',
  'EK Position {n}': 'Purchase price line {n}',
  'Aufschlag Position {n}': 'Mark-up line {n}',
  'Fracht Position {n}': 'Freight line {n}',
  'VK Position {n}': 'Sales price line {n}',
  'VK aus EK und Aufschlag berechnen': 'Calculate sales price from purchase price and mark-up',
  'VK Position {n} berechnen': 'Calculate sales price line {n}',
  'Verkauf netto': 'Sales net',
  'Einkauf netto': 'Purchases net',
  'Rohertrag in %': 'Gross profit in %',
  'nicht berechenbar': 'not calculable',
  '{n} Tag Lieferzeit': '{n} day lead time',
  '{n} Tage Lieferzeit': '{n} days lead time',
  '{n} Position übernommen.': '{n} line item added.',
  '{n} Positionen übernommen.': '{n} line items added.',
  '{n} Position übernehmen': 'Add {n} line item',
  '{n} Positionen übernehmen': 'Add {n} line items',
  '{n} Angebot': '{n} offer',
  '{n} Angebote': '{n} offers',
  'überfällig seit {datum}': 'overdue since {datum}',
  'heute fällig': 'due today',
  'fällig {datum}': 'due {datum}',
  'Vorgänge': 'Cases',
  'Lädt …': 'Loading …',
  'Offen': 'Open',
  'Abgeschlossen': 'Completed',
  'Alle': 'All',
  'Meine': 'Mine',
  'Nummer, Betreff, Kunde, Schiff, IMO': 'Number, subject, customer, vessel, IMO',
  'Phase: {name}': 'Phase: {name}',
  'Abgeschlossen seit {datum}': 'Completed since {datum}',
  'Angelegt seit {datum}': 'Created since {datum}',
  'Angelegt {von} bis {bis}': 'Created {von} to {bis}',
  'Abgeschlossen {von} bis {bis}': 'Completed {von} to {bis}',
  'Nur überfällige': 'Overdue only',
  'Board': 'Board',
  'Liste': 'List',
  'Keine Vorgänge': 'No cases',
  'Keine Vorgänge gefunden': 'No cases found',
  'Filter oder Suche anpassen.': 'Adjust the filter or search.',
  'Fälligkeit': 'Due date',
  'ohne Kunde': 'no customer',
  '{n} neue Nachricht im Vorgang': '{n} new message in this case',
  '{n} neue Nachrichten im Vorgang': '{n} new messages in this case',
  '{n} Vorgang': '{n} case',
  '{n} Vorgänge': '{n} cases',
  'Vorgang nicht gefunden': 'Case not found',
  'Zur Vorgangsliste': 'Go to case list',
  'Innergemeinschaftliche Lieferung ohne USt-IdNr. des Kunden. Ohne gültige USt-IdNr. ist die Lieferung nicht steuerfrei.': 'Intra-Community supply without the customer’s VAT ID. Without a valid VAT ID the supply is not tax-exempt.',
  'Steuerart Seeschifffahrt, aber dem Vorgang ist kein Schiff zugeordnet.': 'Tax category seagoing shipping, but no vessel is assigned to this case.',
  'Steuerart Seeschifffahrt, aber das Schiff hat keine IMO-Nummer.': 'Tax category seagoing shipping, but the vessel has no IMO number.',
  'Keine Positionen erfasst': 'No line items entered',
  'Marge': 'Margin',
  'Keine Kalkulation vorhanden': 'No costing available',
  '{p} % Rohertrag (Ziel mindestens 20 %)': '{p} % gross profit (target at least 20 %)',
  'Steuerart': 'Tax category',
  ', Angaben fehlen': ', details missing',
  ', Angaben vollständig': ', details complete',
  'Kein Kunde zugeordnet': 'No customer assigned',
  'Kreditlimit': 'Credit limit',
  'Vorkasse vereinbart': 'Payment in advance agreed',
  'Freies Limit überschritten': 'Available limit exceeded',
  'Im freien Limit, 50 % Anzahlung vereinbart': 'Within available limit, 50 % advance payment agreed',
  'Im freien Limit': 'Within available limit',
  'Lieferzeiten': 'Lead times',
  'Für alle Positionen erfasst': 'Entered for all line items',
  '{n} ohne Lieferzeit': '{n} without lead time',
  'Rechnung': 'Invoice',
  'Vorkasse': 'Payment in advance',
  'Zahlungsart für diesen Vorgang: {art}.': 'Payment method for this case: {art}.',
  'Zahlungsart wieder wie beim Kunden.': 'Payment method reset to customer default.',
  'Zurück zu {schritt}. Alle Daten bleiben erhalten.': 'Back to {schritt}. All data is retained.',
  'Schritt: {schritt}': 'Step: {schritt}',
  'Zurück zu {schritt}?': 'Back to {schritt}?',
  "Zum Vorgang gibt es bereits die Auftragsbestätigung": "This case already has the order confirmation",
  'Die Auftragsbestätigung bleibt gültig. Bei geänderten Positionen eine neue Angebotsfassung oder eine geänderte AB erstellen.': 'The Order Confirmation remains valid. If line items change, create a new quotation revision or an amended Order Confirmation.',
  'Zurückspringen': 'Step back',
  'Auftrag trotzdem freigeben?': 'Approve order anyway?',
  'Nicht erfüllt: {liste}.': 'Not met: {liste}.',
  'Trotzdem freigeben': 'Approve anyway',
  'Auftrag freigegeben trotz offener Punkte: {liste}': 'Order approved despite open points: {liste}',
  'Auftrag freigegeben, Prüfliste erfüllt': 'Order approved, checklist met',
  'nicht zugeordnet': 'not assigned',
  'kein Schiff': 'no vessel',
  'kein Kontakt': 'no contact',
  'niemand': 'nobody',
  'Fällig': 'Due',
  'ohne Datum': 'no date',
  'keine': 'none',
  'Bestellnummer': 'Order number',
  'noch keine': 'none yet',
  'nicht festgelegt': 'not set',
  'Zahlungsart': 'Payment method',
  'abweichend': 'overridden',
  'wie Kunde': 'as customer',
  'Zahlungsart für diesen Vorgang': 'Payment method for this case',
  'Wie beim Kunden ({art})': 'As for customer ({art})',
  '50/50: 50 % bei Auftragsbestätigung, 50 % bei Versandbereitschaft': '50/50: 50 % on order confirmation, 50 % when ready for dispatch',
  "Erscheint als Zahlungsbedingung auf Angebot, Auftragsbestätigung und Rechnung. Bereits ausgestellte Belege bleiben unverändert.": "Shown as payment terms on quotation, order confirmation and invoice. Documents already issued remain unchanged.",
  'überschritten': 'exceeded',
  'im Rahmen': 'within limit',
  'Limit': 'Limit',
  'Offene Posten': 'Open Items',
  'Offene Vorgänge': 'Open cases',
  'Frei': 'Available',
  'Der erwartete Auftragswert übersteigt das freie Limit um': 'The expected order value exceeds the available limit by',
  'Limit anheben lassen oder Vorkasse vereinbaren.': 'Have the limit raised or agree payment in advance.',
  'Prozessschritte': 'Process steps',
  'Schritt {n} von {gesamt}': 'Step {n} of {gesamt}',
  'Schritt wählen': 'Select step',
  ' (entfällt bei Rechnung)': ' (not applicable for invoice terms)',
  'Weiter zu {schritt}': 'Continue to {schritt}',
  ' (entfällt)': ' (not applicable)',
  'Freigabe': 'Approval',
  'Prüfliste zur Freigabe': 'Approval checklist',
  'Auftrag freigeben': 'Approve order',
  'Die Freigabe erfolgt durch eine Person mit dem Recht „Aufträge freigeben“.': 'Approval is given by a person with the “Approve orders” permission.',
  'Nachrichten': 'Messages',
  'Belege': 'Documents',
  'Verlauf': 'History',
  '{n} Position': '{n} line item',
  '{n} Positionen': '{n} line items',
  '{n} Tag überfällig': '{n} day overdue',
  '{n} Tage überfällig': '{n} days overdue',
  '7 Tage': '7 days',
  'Monat': 'Month',
  'Jahr': 'Year',
  'Anzahlung abwarten': 'Awaiting advance payment',
  '{n} geändert': '{n} changed',
  '{n} neu': '{n} new',
  '{n} gestrichen': '{n} removed',
  'Noch keine Lieferantenangebote zu dieser Position.': 'No supplier offers for this line item yet.',
  'Lieferanten-Nr.': 'Supplier part no.',
  'Lieferanten-Bezeichnung': 'Supplier description',
  'Lieferzeit': 'Lead time',
  'Gültig bis': 'Valid until',
  'günstigstes': 'cheapest',
  'schnellstes': 'fastest',
  'abgelaufen': 'expired',
  'ohne VK': 'no sales price',
  'Wählt …': 'Selecting …',
  'Wählen': 'Select',
  'Angebot {name} bearbeiten': 'Edit offer {name}',
  'Angebot {name} löschen': 'Delete offer {name}',
  'Angebot erfassen': 'Add offer',
  'Letzter EK laut Artikelstamm {preis} €': 'Last purchase price per item master {preis} €',
  'Bitte einen Lieferanten wählen.': 'Please select a supplier.',
  'Bitte den EK pro Stück eingeben.': 'Please enter the purchase price each.',
  'Die Lieferzeit bitte in ganzen Tagen angeben.': 'Please enter the lead time in whole days.',
  'Angebot gespeichert.': 'Offer saved.',
  'Angebot erfasst.': 'Offer added.',
  'Angebot bearbeiten': 'Edit offer',
  'Ändern': 'Change',
  'Lieferant suchen': 'Search supplier',
  'Kein passender Lieferant ohne Angebot zu dieser Position.': 'No matching supplier without an offer for this line item.',
  'Wird beim Wählen mit dem Stammartikel verknüpft.': 'Linked to the master item when selected.',
  'EK pro Stück (€)': 'Purchase price each (€)',
  'Fracht gesamt (€)': 'Total freight (€)',
  'Menge {menge}': 'Quantity {menge}',
  'Teilenummer {nr}': 'Part number {nr}',
  'Bezeichnung ähnlich': 'Similar description',
  'Mehrere Zeilen für dieselbe Position': 'Several lines for the same line item',
  'Je Position und Lieferant gibt es ein Angebot. Es gilt jeweils die letzte Zeile.': 'There is one offer per line item and supplier. The last line applies in each case.',
  'Fortfahren': 'Continue',
  'Lieferantenangebot aus Text übernehmen': 'Import supplier offer from text',
  'Zeilen werden den Positionen zugeordnet, Preise aus der letzten Zahl der Zeile vorbelegt': 'Lines are matched to line items, prices prefilled from the last number in each line',
  'Lieferant wählen': 'Select supplier',
  'Text des Angebots': 'Offer text',
  'Angebotszeilen aus Mail oder PDF einfügen, je Artikel eine Zeile': 'Paste offer lines from email or PDF, one line per item',
  'Ordnet zu …': 'Matching …',
  'Zeilen zuordnen': 'Match lines',
  'Keine passenden Zeilen': 'No matching lines',
  'Im Text wurden weder Preise noch Positionen dieses Vorgangs gefunden.': 'Neither prices nor line items of this case were found in the text.',
  'Jede Zeile prüfen und anhaken. Gespeichert werden nur angehakte Zeilen mit Position und Preis.': 'Check and tick each line. Only ticked lines with a line item and price are saved.',
  'Zeile {n} übernehmen': 'Import line {n}',
  'Position': 'Line item',
  'Keine Position': 'No line item',
  'EK €': 'Purchase price €',
  'Zuordnung {wert}': 'Match {wert}',
  'Keine Position erkannt': 'No line item detected',
  'Kein Preis erkannt': 'No price detected',
  '{n} Tag': '{n} day',
  '{n} Tage': '{n} days',
  '{n} Angebot übernommen.': '{n} offer imported.',
  '{n} Angebote übernommen.': '{n} offers imported.',
  '{n} Angebot speichern': 'Save {n} offer',
  '{n} Angebote speichern': 'Save {n} offers',
  'Erkannt': 'Detected',
  'Vorschlag': 'Suggestion',
  'Herstellernummer {nr}': 'Manufacturer part no. {nr}',
  'Übernehmen': 'Apply',
  'Vorschlag ablehnen': 'Reject suggestion',
  'Ablehnen': 'Reject',
  'Mit Artikelstamm verknüpft, Artikelakte öffnen': 'Linked to item master, open item record',
  'Stamm': 'Master',
  '{n} Alternative': '{n} alternative',
  '{n} Alternativen': '{n} alternatives',
  "Lieferanten anfragen": "Request supplier quotations",
  "Bezugsquelle": "Source",
  "Bezugsquelle {preis} vom {datum}": "Source {preis} dated {datum}",
  "Lieferant im Artikelstamm": "Supplier in item master",
  "Zuletzt für {marke} gewählt": "Last chosen for {marke}",
  "Führt {marke}": "Supplies {marke}",
  "Manuell hinzugefügt": "Added manually",
  "Es ist kein Postfach gewählt, aus dem du senden darfst.": "No mailbox selected that you may send from.",
  "Ohne E-Mail-Adresse: {namen}. Bitte im Lieferantenstamm ergänzen oder abwählen.": "No email address: {namen}. Please add it in the supplier record or deselect.",
  "Anfrage an {n} Lieferanten gesendet.": "Enquiry sent to {n} supplier.",
  "Anfragen an {n} Lieferanten gesendet.": "Enquiries sent to {n} suppliers.",
  "Erst Positionen erfassen, dann können Lieferanten angefragt werden.": "Add line items first, then suppliers can be asked for quotations.",
  "Kein passender Lieferant bekannt. Bitte manuell auswählen.": "No matching supplier known. Please select one manually.",
  "keine E-Mail-Adresse": "no email address",
  "angefragt {datum}": "requested {datum}",
  "Weiteren Lieferanten für Position {n} hinzufügen": "Add another supplier for item {n}",
  "Weiteren Lieferanten hinzufügen …": "Add another supplier …",
  "Englisch": "English",
  "Deutsch": "German",
  "Absender": "Sender",
  "Sendet …": "Sending …",
  "Anfrage an {n} Lieferanten senden": "Send enquiry to {n} supplier",
  "Anfragen an {n} Lieferanten senden": "Send enquiries to {n} suppliers",
  "Jeder Lieferant erhält nur seine Positionen, ohne Angaben zum Kunden. Text aus dem Textbaustein „Lieferantenanfrage“ in der Sprache des Lieferanten, Signatur des Absenders.": "Each supplier receives only its own items, without customer details. Text from the template “Lieferantenanfrage” in the supplier's language, with the sender's signature.",
  "bestellt, AB offen": "ordered, acknowledgement pending",
  "bestätigt": "confirmed",
  "eingegangen": "received",
  "storniert": "cancelled",
  "Bestellung {nummer} erfasst.": "Purchase order {nummer} recorded.",
  "Auftragsbestätigung erfasst.": "Order acknowledgement recorded.",
  "Bestellung {nummer} stornieren?": "Cancel purchase order {nummer}?",
  "Die Positionen werden wieder als offen geführt. Bitte den Lieferanten gesondert informieren.": "The items will be listed as open again. Please inform the supplier separately.",
  "Die Zahlung des Kunden steht noch aus. Bestelle erst nach Zahlungseingang, außer es ist anders vereinbart.": "The customer's payment is still outstanding. Only order after payment has been received unless agreed otherwise.",
  "Keine Positionen zu bestellen.": "No items to order.",
  "Bestellt": "Ordered",
  "Liefertermin": "Delivery date",
  "ohne Mail erfasst": "recorded without email",
  "Bestellung als PDF": "Purchase order as PDF",
  "AB erfassen": "Record acknowledgement",
  "AB anfordern": "Chase acknowledgement",
  "Termin ändern": "Change date",
  "AB-Nummer des Lieferanten": "Supplier acknowledgement no.",
  "AB vom": "Acknowledgement dated",
  "Bestellung senden": "Send purchase order",
  "Zum Beispiel telefonisch oder im Lieferantenportal bestellt": "For example ordered by phone or in the supplier portal",
  "Nur erfassen": "Record only",
  "Ohne Lieferant": "Without supplier",
  "In der Kalkulation ist kein Lieferant gewählt. Bitte hier zuordnen.": "No supplier selected in the costing. Please assign one here.",
  "Lieferant für Position {n}": "Supplier for item {n}",
  "Lieferant wählen …": "Choose supplier …",
  "Ohne das Recht „Einkaufspreise sehen“ enthält die Bestellung keine Preise.": "Without the permission “See purchase prices” the purchase order contains no prices.",
  "Auftragsbestätigung anfordern": "Chase order acknowledgement",
  "Bestellung {nummer} senden": "Send purchase order {nummer}",
  "vollständig": "complete",
  "Teillieferung": "Partial delivery",
  "Teil": "Part",
  "Eingegangen": "Received",
  "Termin {datum}": "Due {datum}",
  "nicht bestellt": "not ordered",
  "Eingegangene Menge Position {n}": "Received quantity item {n}",
  "Vollständig": "Complete",
  "Alles vollständig eingegangen": "Everything received in full",
  "Kunden über den Wareneingang informieren": "Inform customer about goods received",
  "Lieferschein als Entwurf angelegt, Ausstellen nicht möglich: {fehler}": "Delivery note created as a draft; it could not be issued: {fehler}",
  "Lieferschein erzeugt.": "Delivery note created.",
  "Sendung erfasst.": "Shipment recorded.",
  "Zustellung erfasst.": "Delivery recorded.",
  "Versand und Zustellung": "Shipping and delivery",
  "Lieferschein erzeugen": "Create delivery note",
  "versendet {datum}": "dispatched {datum}",
  "zugestellt {datum}": "delivered {datum}",
  "unterwegs": "in transit",
  "Hafen {hafen}": "Port {hafen}",
  "übergeben an {an}": "handed over to {an}",
  "Versandmitteilung senden": "Send shipping advice",
  "Zustellung bestätigen": "Confirm delivery",
  "Zugestellt am": "Delivered on",
  "Übergeben an": "Handed over to",
  "z. B. Chief Engineer, Agent, Empfang": "e.g. Chief Engineer, agent, reception",
  "Weitere Sendung erfassen": "Record another shipment",
  "Sendung erfassen": "Record shipment",
  "Versandart": "Mode of transport",
  "Spediteur oder Dienstleister": "Forwarder or carrier",
  "Sendungsnummer": "Tracking number",
  "Versendet am": "Dispatched on",
  "Colli": "Packages",
  "Gewicht kg": "Weight kg",
  "Lieferung an": "Delivery to",
  "Agent mit Anschrift": "Agent with address",
  "Anschrift oder Ort": "Address or place",
  "Hafen": "Port",
  "ETA Schiff": "Vessel ETA",
  "Sendung speichern": "Save shipment",
  "Tipp: Vorher den Lieferschein erzeugen, dann geht er mit der Versandmitteilung als PDF mit.": "Tip: create the delivery note first, then it is attached to the shipping advice as a PDF.",
  "{n} Colli": "{n} packages",
  "Handelsrechnung": "Commercial invoice",
  "Zolldaten bei {n} Artikeln gespeichert.": "Customs data saved for {n} items.",
  "Zolldokument für den Versand, Werte aus der Kalkulation. Kein Buchungsbeleg.": "Customs document for shipping, values from the calculation. Not an accounting document.",
  "PDF erzeugen": "Create PDF",
  "Zweck": "Purpose",
  "Schiffsersatzteile im Transit": "Ship's spares in transit",
  "Rücksendung nach Reparatur": "Return after repair",
  "Kostenlos (Gewährleistung)": "Free of charge (warranty)",
  "Lieferbedingung": "Incoterms",
  "Ort (Incoterms)": "Place (Incoterms)",
  "Warenempfänger": "Consignee",
  "Eigene EORI": "Own EORI",
  "Wird für diesen Mandanten im Browser gemerkt": "Remembered for this tenant in the browser",
  "Packstücke": "Packages",
  "Netto kg": "Net kg",
  "Brutto kg": "Gross kg",
  "Bei {n} Positionen fehlen Zolltarifnummer oder Ursprung. Der Zoll verlangt beides.": "{n} lines lack HS code or origin. Customs requires both.",
  "Zolltarif-Nr.": "HS code",
  "kg je Einheit": "kg per unit",
  "Wert je Einheit": "Value per unit",
  "Gesamtwert": "Total value",
  "Zolltarifnummer, Ursprung und Gewicht im Artikelstamm speichern, wo dort noch leer": "Save HS code, origin and weight to the item master where still empty",
  "Für Zoll und Versand außerhalb der EU oder an Schiffe im Transit": "For customs and shipping outside the EU or to vessels in transit",
  "Handelsrechnung erstellen": "Create commercial invoice",
  "Sucht passende Bestellungen …": "Searching matching purchase orders …",
  "Dieser Lieferschein wurde am {datum} schon gescannt. Bitte prüfen, ob die Ware doppelt gebucht würde.": "This delivery note was already scanned on {datum}. Please check whether goods would be booked twice.",
  "{ki} liest den Lieferschein …": "{ki} is reading the delivery note …",
  "Bucht Wareneingang …": "Booking goods receipt …",
  "Wareneingang gebucht, Lieferschein konnte nicht abgelegt werden: {fehler}": "Goods receipt booked, delivery note could not be filed: {fehler}",
  "Lieferschein scannen": "Scan delivery note",
  "Von {ki} gelesen (KI, {s} % sicher). Zuordnung bitte prüfen.": "Read by {ki} (AI, {s} % confidence). Please check the matching.",
  "Ware ohne Versandmitteilung angekommen: Lieferschein hochladen, Merkan findet die Bestellung.": "Goods arrived without shipping notice: upload the delivery note, Merkan finds the purchase order.",
  "Lieferschein hochladen": "Upload delivery note",
  "PDF, Scan oder Foto; bei mehreren Seiten alle Fotos zusammen auswählen. Gesucht wird in allen offenen Bestellungen: über die Bestellnummer (auch mit Tippfehler), die AB-Nummer, den Lieferanten und die gelieferten Artikel.": "PDF, scan or photo; for several pages select all photos together. All open purchase orders are searched: by order number (even with typos), order confirmation number, supplier and delivered items.",
  "Wareneingang gebucht.": "Goods receipt booked.",
  "Das Dokument sieht nicht wie ein Lieferschein aus ({art}).": "The document does not look like a delivery note ({art}).",
  "nicht im Lieferantenstamm": "not in supplier master data",
  "Referenzen auf dem Lieferschein": "References on the delivery note",
  "Passende Bestellungen": "Matching purchase orders",
  "Keine offene Bestellung passt zu diesem Lieferschein.": "No open purchase order matches this delivery note.",
  "bestellt am {datum}": "ordered on {datum}",
  "{a} von {b} Artikeln": "{a} of {b} items",
  "Nur diese": "Only this one",
  "Geliefert": "Delivered",
  "Bestellposition": "Order line",
  "nicht bestellt / nicht buchen": "not ordered / do not book",
  "von Hand gewählt": "selected manually",
  "Eingangsmenge": "Received quantity",
  "mehr als offen": "more than open",
  "Zeilen ohne Zuordnung werden nicht gebucht, der Lieferschein wird trotzdem mit ihnen abgelegt.": "Lines without matching are not booked; the delivery note is still filed with them.",
  "Wareneingang buchen ({n} Zeile)": "Book goods receipt ({n} line)",
  "Wareneingang buchen ({n} Zeilen)": "Book goods receipt ({n} lines)",
  "Wareneingang für {n} Position gebucht.": "Goods receipt booked for {n} line.",
  "Wareneingang für {n} Positionen gebucht.": "Goods receipt booked for {n} lines.",
  "Bei {n} Zeile ist mehr geliefert als offen. Überlieferung prüfen oder Menge anpassen.": "{n} line delivers more than open. Check over-delivery or adjust quantity.",
  "Bei {n} Zeilen ist mehr geliefert als offen. Überlieferung prüfen oder Menge anpassen.": "{n} lines deliver more than open. Check over-delivery or adjust quantity.",
  "Bestellnummer ähnlich (Tippfehler)": "Order number similar (typo)",
  "Teilenummer ähnlich": "Part number similar",
  "Stammartikel": "Master item",
  "bereits vollständig eingegangen": "already fully received",
  "Die meisten Positionen sind bereits vollständig eingegangen. Vermutlich wurde diese Ware schon mit einem anderen Lieferschein gebucht.": "Most lines have already been fully received. These goods were probably already booked with another delivery note.",
  "Dieser Lieferschein wurde am {datum} schon gescannt. Die Eingangsmengen stehen deshalb auf 0; nur eintragen, wenn wirklich neue Ware angekommen ist.": "This delivery note was already scanned on {datum}. Received quantities are therefore set to 0; only enter them if new goods have really arrived.",
  // Branchenneutrale Fassungen (Mandanten ohne Schiffsakte)
  "Nummer, Betreff, Kunde, Referenz": "Number, subject, customer, reference",
  "z. B. Anfrage Ersatzteile Kompressor": "e.g. enquiry spare parts compressor",
  "Für Zoll und Versand außerhalb der EU": "For customs and shipments outside the EU",
  "Voraussichtliche Ankunft": "Estimated arrival",

  // IHM-Unterlagen (LG-05)
  "Abteilung": "Department",
  "Bei {n} Positionen fehlt die Angabe. Bitte je Position aus der Erklärung des Herstellers übernehmen.": "{n} positions have no entry. Please take the details for each position from the manufacturer's declaration.",
  "Bei {n} Positionen mit enthaltenen Stoffen fehlt der Stoff.": "{n} positions marked as containing hazardous materials have no material selected.",
  "Die Erklärung gibt die Angaben der Hersteller weiter. Ohne Herstellerangabe bitte beim Lieferanten eine Material Declaration anfordern.": "The declaration passes on the manufacturers' details. Without a manufacturer statement, please request a Material Declaration from the supplier.",
  "Enthält Stoffe": "Contains materials",
  "Erscheint in der SDoC und in jeder Material Declaration, z. B. Schiff, IMO, Bestellnummer.": "Shown in the SDoC and in every Material Declaration, e.g. vessel, IMO, order number.",
  "Gefahrstoffe über Schwellenwert": "Hazardous materials above threshold",
  "Grundlage": "Source",
  "IHM-Angaben bei {n} Artikeln gespeichert.": "IHM data saved for {n} items.",
  "IHM-Angaben im Artikelstamm speichern, damit sie beim nächsten Versand vorbelegt sind": "Save IHM data in the item master so it is prefilled for the next shipment",
  "IHM-Unterlagen": "IHM documents",
  "IHM-Unterlagen erstellen": "Create IHM documents",
  "Keine (frei)": "None (free)",
  "Masse": "Mass",
  "Material Declaration je Position und SDoC für Lieferungen an Schiffe": "Material Declaration per position and SDoC for deliveries to vessels",
  "Noch offen": "Still open",
  "Offene als frei setzen": "Set open ones to free",
  "SDoC-Nummer": "SDoC number",
  "Stoff": "Material",
  "Stoff entfernen": "Remove material",
  "Stoff wählen": "Select material",
  "Supplier's Declaration of Conformity und je Position eine Material Declaration nach IMO MEPC.379(80) und EU-Verordnung 1257/2013, auf Englisch.": "Supplier's Declaration of Conformity and one Material Declaration per position according to IMO MEPC.379(80) and EU Regulation 1257/2013, in English.",
  "Tabelle {t}": "Table {t}",
  "Unterzeichner und Kontaktperson": "Signatory and contact person",
  "Weitere Angaben": "Additional information",
  "Wo verwendet": "Where used",
  "Wo verwendet, z. B. Lötstellen": "Where used, e.g. solder joints",
  "z. B. MD des Herstellers Nr. …": "e.g. manufacturer MD no. …",

  // Versandunterlagen (LG-05)
  "Bei jeder Sendung": "For every shipment",
  "Empfohlen": "Recommended",
  "Für diese Sendung fehlen noch: {liste}.": "Still missing for this shipment: {liste}.",
  "Gehen automatisch mit der Versandmitteilung mit: {liste}": "Attached automatically to the shipping advice: {liste}",
  "Handelsrechnung gespeichert. Sie geht mit der Versandmitteilung mit.": "Commercial invoice saved. It will be attached to the shipping advice.",
  "IHM-Unterlagen gespeichert. Sie gehen mit der Versandmitteilung mit.": "IHM documents saved. They will be attached to the shipping advice.",
  "Lieferung an ein Schiff: Die IHM-Unterlagen sind noch nicht vollständig. Bitte vor dem Versand erstellen, dann gehen sie mit der Versandmitteilung mit.": "Delivery to a vessel: the IHM documents are not complete yet. Please create them before shipping, then they will be attached to the shipping advice.",
  "Pflicht: Lieferung an ein Schiff (MD je Position und SDoC)": "Required: delivery to a vessel (MD per item and SDoC)",
  "Pflicht: Versand außerhalb der EU (Zoll)": "Required: shipment outside the EU (customs)",
  "Positionen geändert": "Items changed",
  "Positionen oder Mengen haben sich seit dem Speichern geändert": "Items or quantities have changed since saving",
  "Reedereien verlangen für jedes an Bord gelieferte Teil eine Material Declaration und eine SDoC des Lieferanten.": "Ship owners require a Material Declaration and a supplier's SDoC for every item delivered on board.",
  "Speichern und PDF": "Save and PDF",
  "Unvollständig": "Incomplete",
  "Versandunterlagen": "Shipping documents",
  "Versandunterlagen herunterladen": "Download shipping documents",
  "Vorhanden": "Available",
  "Wird erstellt …": "Creating …",
  "noch nichts": "nothing yet",
  // Quereinstieg aus Dokument
  'Als Auftrag': 'As order',
  'Als erledigt übernommen: {schritte}.': 'Taken over as done: {schritte}.',
  'Artikel im Stamm erkannt': 'Item recognised in master data',
  'Aus Dokument': 'From document',
  'Bei einer Bestellung des Kunden folgt die Freigabe mit Auftragsbestätigung.': 'For a customer order, release with order confirmation comes next.',
  'Bestellung des Kunden': 'Customer order',
  'Bestellung des Kunden oder Auftragsbestätigung einlesen und den Vorgang direkt ab dem passenden Schritt starten.': 'Read a customer order or order confirmation and start the case directly at the matching step.',
  'Bestellung oder Auftragsbestätigung des Kunden einlesen und ab dem passenden Schritt starten': 'Read a customer order or order confirmation and start at the matching step',
  'Bestellung oder Auftragsbestätigung des Kunden lesen und daraus einen Vorgang anlegen': 'Read a customer order or order confirmation and create a case from it',
  'Der Auftrag wird eingelesen': 'Reading the order',
  'Der Vorgang beginnt am Anfang.': 'The case starts at the beginning.',
  'Die Auftragsbestätigung liegt schon vor, weiter geht es mit der Beschaffung.': 'The order confirmation already exists; procurement comes next.',
  'Dokument': 'Document',
  'Dokument hochladen': 'Upload document',
  'Dokument hochladen oder fotografieren': 'Upload or photograph document',
  'Erkannt wurde {art}. Für den Quereinstieg passen eine Bestellung des Kunden oder eine Auftragsbestätigung; die Angaben lassen sich trotzdem übernehmen.': 'Recognised as {art}. A customer order or an order confirmation fits best for a mid-process start; the details can still be used.',
  'Gleich steht der Vorgang bereit': 'The case is almost ready',
  'Im Dokument: {name}': 'In the document: {name}',
  'Kein Treffer im Kundenstamm.': 'No match in customer master data.',
  'Keine Positionen erkannt. Positionen lassen sich im Vorgang erfassen.': 'No line items recognised. Line items can be added in the case.',
  'Kunde und Bestellnummer werden gesucht': 'Looking for customer and order number',
  'Kunden anlegen': 'Create customer',
  'Lieferanschrift oder Hafen': 'Delivery address or port',
  'Netto laut Dokument': 'Net per document',
  'PDF, Scan oder Foto; bei mehreren Seiten alle Fotos zusammen auswählen. Gelesen werden Kunde, Bestellnummer, Schiff und IMO sowie die Positionen. Die Vorgangsnummer vergibt Merkan beim Anlegen.': 'PDF, scan or photo; for several pages select all photos together. Customer, order number, vessel and IMO plus line items are read. Merkan assigns the case number on creation.',
  'Position übernehmen': 'Take over line item',
  'Schiff und IMO werden gelesen': 'Reading vessel and IMO',
  'Vorgang aus Dokument': 'Case from document',
  'Vorgang wird angelegt …': 'Creating case …',
  'Vorgang {nummer} angelegt, weiter ab {schritt}.': 'Case {nummer} created, continuing at {schritt}.',
  'Weiter ab Schritt': 'Continue at step',
  'Zu dieser Bestellnummer gibt es schon einen Vorgang:': 'A case already exists for this order number:',
  '{art} von {ki} gelesen ({s} % sicher). Bitte prüfen.': '{art} read by {ki} ({s} % confidence). Please check.',
  '{ki} liest das Dokument …': '{ki} is reading the document …',
  '{n} Position wird übernommen': '{n} line item will be taken over',
  '{n} Positionen werden übernommen': '{n} line items will be taken over',
} satisfies Record<string, string>;
